<template>
  <b-sidebar
    v-if="isOpenLocal"
    v-model="isOpenLocal"
    id="sidebar-right-bdr2026-1c-dict"
    :title="editedItemLocal.id ? `Редактирование #${editedItemLocal.id}` : 'Добавление свойства'"
    right
    backdrop
    shadow
    width="45em"
    backdrop-variant="dark"
    no-close-on-backdrop
  >
    <div class="d-block">
      <b-row class="my-2" style="align-items: center;">
        <b-col sm="3">
          <label for="input-1c-name-2026">Название из файла</label>
        </b-col>
        <b-col sm="9">
          <b-form-input
            v-model="editedItemLocal.name_from_file"
            id="input-1c-name-2026"
            size="sm"
          />
        </b-col>
      </b-row>
      <b-row class="my-2">
        <b-col sm="12">
          <label class="mb-2">Доли по юнитам (%)</label>
        </b-col>
        <b-col sm="4" class="mb-2">
          <label class="small text-muted">B2B</label>
          <b-form-input
            v-model.number="unitPercents.B2B"
            type="number"
            min="0"
            max="100"
            size="sm"
            placeholder="0"
            @input="onUnitPercentsChange"
          />
        </b-col>
        <b-col sm="4" class="mb-2">
          <label class="small text-muted">B2C</label>
          <b-form-input
            v-model.number="unitPercents.B2C"
            type="number"
            min="0"
            max="100"
            size="sm"
            placeholder="0"
            @input="onUnitPercentsChange"
          />
        </b-col>
        <b-col sm="4" class="mb-2">
          <label class="small text-muted">БСЗ</label>
          <b-form-input
            v-model.number="unitPercents.БСЗ"
            type="number"
            min="0"
            max="100"
            size="sm"
            placeholder="0"
            @input="onUnitPercentsChange"
          />
        </b-col>
        <b-col sm="12">
          <small class="text-muted">Заполните только нужные юниты (например: B2B 50, B2C 50).</small>
        </b-col>
      </b-row>
      <b-row class="my-2" v-if="localSplits.length">
        <b-col sm="12">
          <label class="mb-2">Привязка к статье по каждому юниту</label>
        </b-col>
        <b-col sm="12" v-for="(split, idx) in localSplits" :key="split.unit" class="mb-2">
          <div class="d-flex align-items-center">
            <span class="mr-2" style="min-width: 80px;">{{ split.perc }}% {{ split.unit }}</span>
            <b-form-select
              v-model="split.bdr2026_dictionary_id"
              :options="optionsForUnit(split.unit, split.bdr2026_dictionary_id)"
              size="sm"
              class="flex-grow-1"
            />
          </div>
        </b-col>
      </b-row>
      <b-row class="my-2" style="align-items: center;">
        <b-col sm="3">
          <label for="input-1c-always-2026">Пропускать строки с таким наименованием?</label>
        </b-col>
        <b-col sm="9">
          <b-form-checkbox
            id="input-1c-always-2026"
            v-model="editedItemLocal.always_pass"
            :value="1"
            :unchecked-value="0"
          >
            Пропускать
          </b-form-checkbox>
        </b-col>
      </b-row>
      <div class="d-flex mt-2 mb-2">
        <b-button size="md" class="ml-auto btn btn-secondary" @click="closeSidebar()" :disabled="loading">
          Отмена
        </b-button>
        <b-button size="md" class="ml-2 btn btn-primary" @click="saveElement()">
          Сохранить <b-icon v-if="loading" icon="arrow-repeat" scale="1.2" :animation="loading ? 'spin' : ''"></b-icon>
        </b-button>
      </div>
    </div>
  </b-sidebar>
</template>

<script>
import { API_BDR2026_1C_DICTIONARY, API_BDR2026_DICTIONARY } from '@/constants';

const UNIT_KEYS = ['B2B', 'B2C', 'БСЗ'];

function defaultUnitPercents() {
  return { B2B: null, B2C: null, БСЗ: null };
}

function parseUnitPercent(str) {
  const value = (str || '').trim().replace(/[\s\-;:]/g, '');
  if (!value) return [];
  const units = [];
  value.split(',').forEach(part => {
    if (!part) return;
    const p = part.split('%');
    if (p.length === 1) units.push({ perc: 100, unit: (p[0] || '').trim() });
    else units.push({ perc: parseFloat(p[0]) || 0, unit: (p[1] || '').trim() });
  });
  return units.filter(u => UNIT_KEYS.includes(u.unit));
}

export default {
  name: 'Bdr2026OneCSidebar',
  props: {
    isOpen: { type: Boolean, required: true },
    editedItem: {
      type: Object,
      default: () => ({ name_from_file: '', bdr2026_dictionary_id: null, unit_percent: '', always_pass: 0, property: {}, splits: [] })
    },
    unit: { type: String, default: 'B2B' }
  },
  data() {
    return {
      loading: false,
      parentOptionsByUnit: {},
      unitPercents: defaultUnitPercents(),
      localUnitPercent: '',
      localSplits: []
    };
  },
  watch: {
    isOpen(val) {
      if (val) {
        this.getDictionary();
        this.syncFromEditedItem();
      }
    },
    editedItem: {
      handler() { this.syncFromEditedItem(); },
      deep: true
    }
  },
  computed: {
    isOpenLocal: {
      get() { return this.isOpen; },
      set(value) { this.$emit('update:isOpen', value); }
    },
    editedItemLocal: {
      get() { return this.editedItem; },
      set() {}
    }
  },
  methods: {
    syncFromEditedItem() {
      const item = this.editedItem || {};
      this.unitPercents = defaultUnitPercents();
      const splits = item.splits && item.splits.length ? item.splits : null;
      if (splits && splits.length) {
        splits.forEach(s => {
          const u = s.unit && UNIT_KEYS.includes(s.unit) ? s.unit : 'B2B';
          this.$set(this.unitPercents, u, s.perc != null ? Number(s.perc) : 100);
        });
        this.localSplits = splits.map(s => ({
          unit: s.unit && UNIT_KEYS.includes(s.unit) ? s.unit : 'B2B',
          perc: s.perc != null ? Number(s.perc) : 100,
          bdr2026_dictionary_id: s.bdr2026_dictionary_id != null ? s.bdr2026_dictionary_id : null
        }));
      } else {
        const up = (item.unit_percent || '100%B2B').trim();
        const parsed = parseUnitPercent(up);
        if (parsed.length) {
          parsed.forEach(p => {
            this.$set(this.unitPercents, p.unit, p.perc);
          });
        } else {
          this.$set(this.unitPercents, 'B2B', 100);
        }
        const singleDictId = item.bdr2026_dictionary_id != null ? item.bdr2026_dictionary_id : null;
        this.localSplits = parsed.length
          ? parsed.map(p => ({ unit: p.unit, perc: p.perc, bdr2026_dictionary_id: singleDictId }))
          : [{ unit: 'B2B', perc: 100, bdr2026_dictionary_id: singleDictId }];
      }
      this.localUnitPercent = this.localSplits.map(s => s.perc + '%' + s.unit).join(',');
    },
    onUnitPercentsChange() {
      const rows = [];
      UNIT_KEYS.forEach(u => {
        const v = this.unitPercents[u];
        const perc = (v === '' || v === null || v === undefined || isNaN(v)) ? 0 : Math.max(0, Math.min(100, Number(v)));
        if (perc > 0) {
          const existing = this.localSplits.find(s => s.unit === u);
          const opts = (this.parentOptionsByUnit[u] || []).map(o => o.value);
          const dictId = existing && opts.indexOf(existing.bdr2026_dictionary_id) !== -1
            ? existing.bdr2026_dictionary_id
            : null;
          rows.push({ unit: u, perc, bdr2026_dictionary_id: dictId });
        }
      });
      if (rows.length === 0) {
        this.$set(this.unitPercents, 'B2B', 100);
        rows.push({ unit: 'B2B', perc: 100, bdr2026_dictionary_id: this.localSplits[0] ? this.localSplits[0].bdr2026_dictionary_id : null });
      }
      this.localSplits = rows;
      this.localUnitPercent = this.localSplits.map(s => s.perc + '%' + s.unit).join(',');
    },
    optionsForUnit(unit, selectedId) {
      const base = [{ value: null, text: '— не выбрано —' }];
      const key = this.normalizeUnitKey(unit);
      let list = (key && this.parentOptionsByUnit[key]) ? this.parentOptionsByUnit[key].slice() : [];
      const hasSelected = selectedId != null && selectedId !== '' && list.some(o => o.value === selectedId);
      if (selectedId != null && selectedId !== '' && !hasSelected) {
        list.push({ value: selectedId, text: selectedId + ': (текущая статья)' });
      }
      return list.length ? base.concat(list) : base;
    },
    normalizeUnitKey(unit) {
      const u = (unit || '').toString().trim();
      if (u === 'B2B' || u === 'B2C' || u === 'БСЗ') return u;
      return u || 'B2B';
    },
    getDictionary() {
      this.loading = true;
      const units = ['B2B', 'B2C', 'БСЗ'];
      const next = {};
      let pending = units.length;
      const done = () => {
        pending--;
        if (pending === 0) this.loading = false;
      };
      units.forEach(u => {
        const url = `${API_BDR2026_DICTIONARY}?easylist=true&unit=${encodeURIComponent(u)}`;
        axios.get(url).then(({ data }) => {
          const tree = data || [];
          const withDepth = [];
          this.flattenTreeWithDepth(tree, 0, withDepth);
          next[u] = withDepth.map(n => ({
            value: n.id,
            text: (n.depth ? '—'.repeat(n.depth) + ' ' : '') + `${n.id}: ${n.name}`
          }));
          this.$set(this.parentOptionsByUnit, u, next[u]);
          done();
        }).catch(() => {
          this.$set(this.parentOptionsByUnit, u, []);
          done();
        });
      });
    },
    flattenTreeWithDepth(nodes, depth, out) {
      (nodes || []).forEach(node => {
        out.push({ id: node.id, name: node.name, depth });
        if (node.children && node.children.length) {
          this.flattenTreeWithDepth(node.children, depth + 1, out);
        }
      });
    },
    closeSidebar() {
      this.isOpenLocal = false;
    },
    saveElement() {
      this.loading = true;
      const unitPercent = this.localUnitPercent.trim() || '100%B2B';
      const splits = this.localSplits.map(s => ({
        unit: s.unit,
        perc: s.perc,
        bdr2026_dictionary_id: s.bdr2026_dictionary_id || null
      }));
      const payload = {
        name_from_file: this.editedItemLocal.name_from_file,
        bdr2026_dictionary_id: (splits[0] && splits[0].bdr2026_dictionary_id) || null,
        unit_percent: unitPercent,
        always_pass: this.editedItemLocal.always_pass ? 1 : 0,
        splits
      };
      if (this.editedItemLocal.id) {
        axios.put(`${API_BDR2026_1C_DICTIONARY}/${this.editedItemLocal.id}`, payload)
          .then(({ data }) => {
            this.$emit('updateItem', this.editedItemLocal, data);
            this.loading = false;
            this.closeSidebar();
          })
          .catch(() => { this.loading = false; });
      } else {
        axios.post(API_BDR2026_1C_DICTIONARY, payload)
          .then(({ data }) => {
            this.$emit('updateItem', this.editedItemLocal, data);
            this.loading = false;
            this.closeSidebar();
          })
          .catch(() => { this.loading = false; });
      }
    }
  }
};
</script>
